
import {Component, Prop, Vue} from "vue-property-decorator";
import AuditTrailTable from "@/components/audittrail/AuditTrailTable.vue";
import {auditTrailModule, currentUserModule, studyPatientModule} from "@/store";
import {formatDateTime} from "@/auxillary/date-format";

@Component({
  components: {AuditTrailTable}
})
export default class StudyPatientAuditTrailView extends Vue {
  @Prop({default: ""}) private patientId: string;

  get studyPatientAlias() {
    return studyPatientModule.studyPatient?.displayName ?? "";
  }

  get currentUserDetails() {
    return (currentUserModule.user?.userName ?? "") + " (" + (currentUserModule.roleIdentifier ?? "") + ") " + formatDateTime((new Date().toUTCString()))
  }

  get changes() {
    return auditTrailModule.auditChanges ?? [];
  }

  async mounted() {
    await currentUserModule.loadIfEmpty();
    await studyPatientModule.loadById(this.patientId);
    await auditTrailModule.loadForStuyPatient(this.patientId)
  }

  async back() {
    await this.$router.push({
      name: "patient",
      params: {patientId: this.patientId}
    }).catch();
  }
}
